__turbopack_context__.v({
  "hoverTarget": "O60YUW_hoverTarget",
  "hoverTrigger": "O60YUW_hoverTrigger",
});
